import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function Login() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from ?? "/dataengine/jobs";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    setErr(null);
    try {
      await signIn(email.trim(), password);
      navigate(from, { replace: true });
    } catch (e: any) {
      setErr(e?.message ?? "sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <form onSubmit={onSubmit} style={{
        width: "100%", maxWidth: 360,
        background: "var(--surface)", border: "1px solid var(--rule)", borderRadius: 12,
        padding: "26px 24px 22px",
      }}>
        <div style={{ fontSize: 18, fontWeight: 600, letterSpacing: "-0.015em" }}>
          ProProp<span style={{ color: "var(--accent)" }}>.</span> Admin
        </div>
        <div style={{ fontSize: 11, color: "var(--ink-3)", textTransform: "uppercase", letterSpacing: "0.08em", marginTop: 2 }}>
          Operator sign in
        </div>

        <label style={labelStyle}>Email
          <input
            type="email" autoComplete="username" required value={email}
            onChange={(e) => setEmail(e.target.value)} style={inputStyle}
          />
        </label>
        <label style={labelStyle}>Password
          <input
            type="password" autoComplete="current-password" required value={password}
            onChange={(e) => setPassword(e.target.value)} style={inputStyle}
          />
        </label>

        {err && (
          <div style={{ marginTop: 12, padding: "8px 10px", borderRadius: 6, background: "rgba(122,45,31,0.08)", color: "var(--neg)", fontSize: 12.5 }}>
            {err}
          </div>
        )}

        <button type="submit" disabled={submitting} style={{
          marginTop: 16, width: "100%", padding: "10px 12px", borderRadius: 8,
          border: "none", background: "var(--accent)", color: "#f4f1ea",
          fontWeight: 500, fontSize: 13.5, cursor: submitting ? "default" : "pointer",
          opacity: submitting ? 0.6 : 1,
        }}>
          {submitting ? "Signing in…" : "Sign in"}
        </button>

        <div style={{ marginTop: 16, fontSize: 11, color: "var(--ink-4)", lineHeight: 1.5 }}>
          Admins are created out-of-band with <code>admincli</code>. There is no self-signup.
        </div>
      </form>
    </div>
  );
}

const labelStyle: React.CSSProperties = {
  display: "block", marginTop: 14,
  fontSize: 11, fontWeight: 600, color: "var(--ink-3)",
  letterSpacing: "0.06em", textTransform: "uppercase",
};
const inputStyle: React.CSSProperties = {
  display: "block", width: "100%", marginTop: 6,
  padding: "8px 10px", borderRadius: 6,
  border: "1px solid var(--rule)", background: "var(--bg)",
  fontSize: 13.5, color: "var(--ink)",
  outline: "none",
};
